import { SupplierInformationDto } from "../../../autogen/bff-api";

export interface PublishedDocument {
  id: string;
  name: string;
  uploadedAt: string;
}

export const collectPublishedDocuments = (
  announcements: SupplierInformationDto[],
  existingDocumentIds: Iterable<string>,
): PublishedDocument[] => {
  const excluded = new Set(existingDocumentIds);
  const seen = new Set<string>();
  const documents: PublishedDocument[] = [];
  for (const announcement of announcements) {
    for (const attachment of announcement.attachments ?? []) {
      const id = attachment.documentId;
      if (excluded.has(id) || seen.has(id)) continue;
      seen.add(id);
      documents.push({ id, name: attachment.fileName, uploadedAt: announcement.createdAt });
    }
  }
  return documents;
};
